<!-- Title Section -->
<section>
  <div class="row">
    <!-- Left Section -->
    <div class="col-md-10 col-sm-8">
      <div class="breadcrumb_head">
        <!-- Title -->
        <h1 class="title_main mb-1 lh_42">{{ 'notifications.notifications_list' | translate }}</h1>

        <!-- Breadcrumbs -->
        <app-breadcrumbs></app-breadcrumbs>
      </div>
    </div>

    <!-- Action Buttons -->
    <!-- <div class="col-md-2 col-sm-4 action_button">
        <button
            class="btn btn_primary">
      </button>
    </div> -->
  </div>
</section>

<section class="content_area" [formGroup]="filterForm">
  <!-- Filter Section -->
  <div class="row filter-section mb-4">
    <div class="col-12">
      <!-- Filter Card -->
      <mat-card>
        <mat-card-content>
          <!-- Filter Accordion -->
          <mat-accordion multi>
            <mat-expansion-panel expanded>
              <!-- Title -->
              <mat-expansion-panel-header class="mb-3">
                <mat-panel-title>
                  <h1 class="sub_title_1 text_dark_blue">{{ 'common.filter' | translate }}</h1>
                  <!-- <p>
                    {{
                      'guest.all_centers_all_guests_all_guest_types_all_date_types_all_statuses_all_ip_op' | translate
                    }}
                  </p> -->
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row p-1">
                                <!-- Status -->
                <div class="col-md-3 col-sm-12">
                  <dropdown-multiselect
                    ngDefaultControl
                    [controlName]="'notificationTypeId'"
                    [displayFormat]="'name'"
                    [multiple]="false"
                    [options]="notificationTypesList"
                    [placeholder]="'guest.status' | translate"
                    [valueField]="'id'"
                    [showLoading]="true"
                    [dataLoaded]="isNotificationTypesLoaded">
                  </dropdown-multiselect>
                </div>
                                <!-- Start Date -->
                <div class="col-md-2 col-sm-12 subscript-wrapper-hide" *ngIf="isDateTypeSelected">
                  <mat-form-field appearance="fill">
                    <mat-label>{{ 'guest.start_date' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="fromDate"
                      [matDatepicker]="picker1"
                      [min]="minDate"
                      [max]="currentDate"
                      placeholder="DD/MM/YYYY"
                      appMinDate />
                    <mat-datepicker-toggle matIconSuffix [for]="picker1">
                      <i class="demo-icon icon-calendar" matDatepickerToggleIcon></i>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                  <app-validation-error
                    field="startDate"
                    [control]="filterForm.get(['fromDate'])!"
                    [errorMsg]="'validation.invalid_date' | translate"
                    *ngIf="filterForm.get(['fromDate'])?.hasError('matDatepickerParse')"></app-validation-error>
                  <app-validation-error
                    field="startDate"
                    [control]="filterForm.get(['fromDate'])!"
                    [errorMsg]="'validation.invalid_date' | translate"
                    *ngIf="filterForm.get(['fromDate'])?.errors?.['minDate']"></app-validation-error>
                </div>

                <!-- End Date -->
                <div class="col-md-2 col-sm-12 subscript-wrapper-hide" *ngIf="isDateTypeSelected">
                  <mat-form-field appearance="fill">
                    <mat-label>{{ 'guest.end_date' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="toDate"
                      [matDatepicker]="picker2"
                      [min]="filterForm.get(['fromDate'])?.value || minDate"
                      [max]="currentDate"
                      placeholder="DD/MM/YYYY"
                      appMinDate />
                    <mat-datepicker-toggle matIconSuffix [for]="picker2">
                      <i class="demo-icon icon-calendar" matDatepickerToggleIcon></i>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                  <app-validation-error
                    field="End Date"
                    [control]="filterForm.get(['toDate'])!"
                    [errorMsg]="'validation.invalid_date' | translate"
                    *ngIf="filterForm.get(['toDate'])?.hasError('matDatepickerParse')"></app-validation-error>
                  <app-validation-error
                    field="End Date"
                    [control]="filterForm.get(['toDate'])!"
                    [errorMsg]="'validation.invalid_date' | translate"
                    *ngIf="filterForm.get(['toDate'])?.errors?.['minDate']"></app-validation-error>
                </div>

                    <div class="col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                    <!-- Apply Filters -->
                    <button
                      *ngIf="!loadingOnSave; else buttonLoader"
                      class="btn btn_primary me-3"
                      [disabled]="filterForm.invalid"
                      (click)="onClickApplyFilter()">
                      {{ 'common.apply_filter' | translate }}
                    </button>

                    <!-- Clear All -->
                    <div class="col-2 clear-all">
                      <a class="clear_button" (click)="onClickClearAll()">{{ 'common.clear_all' | translate }}</a>
                    </div>
                  </div>
                  </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Guests List -->
  <div class="row">
    <div class="col-12" *ngIf="displayList">
      <!-- Guests List Card -->
      <mat-card class="mb-4">
        <mat-card-content>
          <div class="row mb-3">
            <!-- Title -->
            <div class="col-7 table-head">
              <h2 class="fw_700 sub_title_2 text_dark_blue mb-1">{{ 'notifications.notifications_list' | translate }}</h2>
              <p class="text_grey">{{ 'notifications.notification_list_are_here' | translate }}</p>
            </div>

            <!-- Search & Download -->
            <div class="col-5 d-flex justify-content-end">
              <!------Search Form------->
              <div class="me-4">
                <!-- Search -->
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'common.search' | translate }}</mat-label>
                  <input matInput formControlName="searchString" />
                </mat-form-field>
              </div>
            </div>

                        <!-- Guests Table -->
            <div class="col-12 mb-3 mt-3" *ngIf="isDataLoaded; else loading">
              <table class="w_100" mat-table [dataSource]="notificationDataSource">
                <!-- Sl No. Column -->
                <ng-container matColumnDef="sl_no">
                  <th mat-header-cell *matHeaderCellDef>{{ 'notifications.table_headers.sl_no' | translate }}</th>
                  <td class="lh_18 mb-1 text_dark_blue" mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 + paginator.pageIndex * paginator.pageSize }}
                  </td>
                </ng-container>

                <!-- Guest Id Column-->
                <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef>{{ 'notifications.table_headers.title' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.title ?? '---' }}
                  </td>
                </ng-container>

                <!-- Guest Name Column -->
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>{{ 'notifications.table_headers.description' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <h4 class="fw_600 lh_18 mb-1 text_dark_blue">{{ element.description }}</h4>
                  </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>{{ 'notifications.table_headers.type' | translate }}</th>
                  <td class="lh_18 mb-1 text_dark_blue" mat-cell *matCellDef="let element">
                    <!--Active status-->
                    <mat-chip class="chip-active" *ngIf="element.isActive === 'True'; else inActive">
                      {{ 'common.active' | translate }}
                    </mat-chip>

                    <!--Inactive status-->
                    <ng-template #inActive>
                      <mat-chip class="chip-inactive"> {{ element.type }} </mat-chip>
                    </ng-template>
                  </td>
                </ng-container>

                <!-- createdAt Column -->
                <ng-container matColumnDef="created_date">
                  <th mat-header-cell *matHeaderCellDef>{{ 'notifications.table_headers.created_date' | translate }}</th>
                  <td class="lh_18 mb-1 text_dark_blue" mat-cell *matCellDef="let element">
                    {{ (element?.createdAt | date : 'dd-MMM-y') ?? '---' }}
                  </td>
                </ng-container>

                <!-- Mobile Number Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'notifications.table_headers.actions' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="d-flex">
                      <!-- View User Button -->
                      <button mat-icon-button (click)="onClickActions()">
                        <i class="demo-class icon-action-view text_light_blue"></i>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <!-- Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  class="mat-table-row"
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"></tr>

                <!-- No Data Row -->
                <tr *matNoDataRow>
                  <td [attr.colspan]="displayedColumns.length">
                    <div class="empty_item">
                      <div class="figure">
                        <img src="assets/images/empty_item.svg" />
                      </div>
                      <span class="empty_text">{{ 'common.no_data_available' | translate }}</span>
                    </div>
                  </td>
                </tr>
              </table>
            </div>




            <!-- Paginator -->
            <mat-paginator
              #paginator
              [length]="filteredNotificationCount"
              [pageSizeOptions]="[15, 30, 60, 90, 100, 500, 1000]"
              (page)="onPageChange($event)"></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</section>


<ng-template #loading>
  <app-table-sklton-loader [displayedColumns]="displayedColumns"></app-table-sklton-loader>
</ng-template>

<ng-template #buttonLoader>
  <button-loader class="me-3"></button-loader>
</ng-template>

<ng-template #downloadbuttonLoader>
  <app-download-button-loader></app-download-button-loader>
</ng-template>